import React from 'react'
import Testimonials from '../homesection/Testimonials'

function FaqComp() {
  return (
    <>
    <Testimonials />
    </>
  )
}

export default FaqComp